import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { Messages } from 'src/app/constants/messages';
import { ZonesServiceService } from 'src/app/modules/plants/plant-details/zones/zones-service.service';
import { ServicecallService } from 'src/app/services/servicecall.service';
import { EntitiesServiceService } from '../../../../services/entities-service.service';

@Component({
  selector: 'app-monotainer-tagging-details',
  templateUrl: './monotainer-tagging-details.component.html',
  styleUrls: ['./monotainer-tagging-details.component.css']
})
export class MonotainerTaggingDetailsComponent implements OnInit, OnDestroy {

  tagMonotainerForm: FormGroup;
  userSubmit: boolean = false;
  destinationList: any = [];
  laneDetails: any = [];
  destination: any;
  showLanes: boolean = true;
  isTagForm: any;
  errorMessage: any = [];
  successMessage: any = [];

  private _updateReaSubscription: Subscription;
  private _fetchLanesSubscription: Subscription;

  constructor(public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _fb: FormBuilder,
    private _sharedService: ServicecallService,
    private _service: EntitiesServiceService,
    private _zoneService: ZonesServiceService) { }

  ngOnInit(): void {
    this._initiazileForm(this.data);
  }
  ngOnDestroy(): void {
    this._updateReaSubscription?.unsubscribe();
    this._fetchLanesSubscription?.unsubscribe();
  }
  onDestinationChange() {
    this._fetchLanes(this.tagMonotainerForm?.value?.destination);
  }

  colorAvailabliltyCheck(value: any) {
    if (value > 70) {
      return '#0c8928';
    } else if (value > 30 && value < 70) {
      return '#d5961a';
    } else if (value < 30) {
      return '#9c1717';
    } else {
      return '#B2BEB5';
    }
  }

  resetForm() {
    this.tagMonotainerForm.reset();
    this.showLanes = false;
  }

  submitForm(type: any) {
    this.userSubmit = true;
    if (this.tagMonotainerForm.invalid && this.userSubmit) {
      return;
    } else {
      const reqData: any = {
        zones: type === 'tag' ? this.laneDetails?.map(({ id }) => id) : [],
        mappingId: this.data?.taggedDetails?.mappingId,
        entityIds: this.data?.taggedDetails?.id,
        siteId: this.data?.taggedDetails?.site ? this.data?.taggedDetails?.site : null,
      }
      this._updateReaSubscription = this._service.updateRea(reqData).subscribe(
        {
          next: (result: any) => {
            if (result) {
              this.successMessage = [];
              this.errorMessage = [];
              if (this.data?.msg === 'multitag' || this.data?.msg === 'multiUntag') {
                result?.entityTagIds?.forEach(success => {
                  this.successMessage.push(success?.uniqueId);
                });
                result?.errorInEntities?.forEach(element => {
                  const error = element?.uniqueId + " - " + element?.error;
                  this.errorMessage.push(error);
                });
              } else {
                if (result?.entityTagIds?.length) {
                  this._sharedService.toasterService({ type: 'success', msg: Messages.SUCCESS });
                } else {
                  this._sharedService.toasterService({ type: 'error', msg: result?.errorInEntities?.[0]?.error });
                }
                this.dialogRef.close(true);
              }
            }
          },
          error: () => {

          }
        }
      )
    }
  }

  closeDialogue() {
    if (this.successMessage.length || this.errorMessage.length) {
      this.dialogRef.close(true);
    } else {
      this.dialogRef.close();
    }
  }
  get tagMonotainerFormValues() {
    return this.tagMonotainerForm.controls;
  }
  private _initiazileForm(details: any) {
    const taggedData = details?.taggedDetails;
    this.tagMonotainerForm = this._fb.group({
      destination: ['', [Validators.required]],
    });
    if (details?.msg === 'map') {
      if (this.data?.taggedDetails?.mappingId) {
        this._getDestination(taggedData?.destination);
        this.laneDetails = taggedData?.lanes;
        this.isTagForm = this.laneDetails?.length ? false : true;
      }
    }
    else {
      this._getDestination();
      this.isTagForm = details?.msg === 'multitag' ? true : false;
      if (details?.msg === 'multiUntag') {
        this.tagMonotainerForm.controls['destination'].removeValidators(Validators.required);
        this.tagMonotainerForm.controls['destination'].updateValueAndValidity();
      }
    }
  }

  /**
   * Gets destination
   * @param [destination] 
   */
  private _getDestination(destination?: any) {
    this._zoneService.zonesWithDestination({ siteId: this.data?.siteId }).subscribe({
      next: (resp: any) => {
        function keyExists(arr, key) {
          return arr.some(item => item.key === key);
        }
        this.destinationList = resp.reduce((acc, curr) => {
          if (!keyExists(acc, curr.destinationKey) && curr.destinationKey !== null) {
            acc.push({ key: curr.destinationKey, name: curr.destinationName });
          }
          return acc;
        }, []);
      }
    });
    this.tagMonotainerForm.patchValue({
      destination: destination
    });
  }

  private _fetchLanes(destination: any) {
    const reqData: any = {
      siteId: this.data?.taggedDetails?.site ? this.data?.taggedDetails?.site : null,
      destination: destination
    }
    this._fetchLanesSubscription = this._service.fetchLanes(reqData).subscribe(
      {
        next: (result: any) => {
          this.laneDetails = result;
          this.showLanes = true;
          this.laneDetails.map((item: any) => {
            item.availability = 100 - item.occupancyPct;
          });
        },
        error: (error) => {
          if (error) {
            this.laneDetails = [];
          }
        }
      }
    )
  }

}
